import {
  ChargeType,
  type PayEncounterPayments,
  type PayEncounterRequestBody,
} from 'features/Procedure/state/procedure-api.type'

import { buildEncounterCheckoutPayload, type CheckoutPreview } from '../checkout.utils'

export type BuildPayEncounterBodyOptions = {
  chargeType?: ChargeType
  payments?: PayEncounterPayments
}

export const buildPayEncounterBody = (
  preview: CheckoutPreview,
  stripeTerminalId: number,
  amount: number | null,
  options: BuildPayEncounterBodyOptions = {},
): PayEncounterRequestBody => {
  const checkoutPayload = buildEncounterCheckoutPayload(preview)

  const base: PayEncounterRequestBody = {
    stripe_terminal_id: stripeTerminalId,
    encounter_tax: checkoutPayload.encounter_tax,
    encounter_balance: checkoutPayload.encounter_balance,
    prepayment_amount: checkoutPayload.prepayment_amount,
    credits_applied: checkoutPayload.credits_applied,
    discounts_applied: checkoutPayload.discounts_applied,
    total_discount: checkoutPayload.total_discount,
    ...(amount !== null ? { amount } : {}),
  }

  if (options.payments) {
    return {
      ...base,
      payments: options.payments,
      ...(options.chargeType ? { charge_type: options.chargeType } : {}),
    }
  }

  if (options.chargeType === ChargeType.ApplyCredit) {
    return {
      ...base,
      charge_type: ChargeType.ApplyCredit,
    }
  }

  return base
}
